import Alert from '~/components/Alert';
import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Input from '~/components/form-controls/Input';
import Page from '~/components/layout/page/Page';
import { ClaimType } from '~/utils/constants';
import { INPUT_KEY, useActionResult, useLoaderData } from './quantity';

export default function QuantityPage() {
  const { currentQuantity, quantity, claimType } = useLoaderData();
  const actionResult = useActionResult();

  const title = [
    claimType === ClaimType.return && `How many do you need to return?`,
    claimType === ClaimType.warranty &&
      `How many of this product do you need help with?`,
    `(${currentQuantity} available)`,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Page.Section title={title}>
      <Form name="claimQuantity">
        <Input
          label="quantity"
          hideLabel
          required
          id="quantity"
          name={INPUT_KEY}
          type="number"
          defaultValue={quantity}
          min="1"
          max={currentQuantity}
          validationMessages={{
            valueMissing: 'Please enter a quantity',
            rangeUnderflow: 'Quantity must be at least 1',
            rangeOverflow: `Quantity must be at most ${currentQuantity}`,
          }}
        />
        {actionResult?.ok === false && (
          <Alert variant="error" title="Problem saving quantity">
            {actionResult.message}
          </Alert>
        )}
        <Submit>Next</Submit>
      </Form>
    </Page.Section>
  );
}
